import React from 'react';
import { PerformanceSummary } from './types';

interface QuickStatsCardsProps {
  performanceSummary: Pick<PerformanceSummary, 'total_quizzes_taken' | 'overall_accuracy_percentage' | 'total_time_spent_minutes' | 'mastery_level'>;
}

const QuickStatsCards: React.FC<QuickStatsCardsProps> = ({ performanceSummary }) => {
  // Helper function to parse numeric values from strings
  const parseNumber = (value: string | number): number => {
    if (typeof value === 'number') return value;
    return parseFloat(value) || 0;
  };

  const formatDuration = (minutes: number) => {
    const hours = Math.floor(minutes / 60);
    const mins = Math.round(minutes % 60);
    return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
  };

  const getMasteryColor = (level: string) => {
    switch (level.toLowerCase()) {
      case 'master':
        return 'text-purple-600';
      case 'expert':
        return 'text-green-600';
      case 'proficient':
        return 'text-blue-600';
      case 'developing':
        return 'text-yellow-600';
      case 'beginner':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <div className="row mb-4">
      <div className="col-md-3 mb-3">
        <div className="card border-primary">
          <div className="card-body text-center">
            <i className="fas fa-tasks fa-2x text-primary mb-2"></i>
            <h3 className="text-primary">{performanceSummary.total_quizzes_taken}</h3>
            <p className="mb-0">Quizzes Completed</p>
          </div>
        </div>
      </div>
      <div className="col-md-3 mb-3">
        <div className="card border-success">
          <div className="card-body text-center">
            <i className="fas fa-bullseye fa-2x text-success mb-2"></i>
            <h3 className="text-success">{parseNumber(performanceSummary.overall_accuracy_percentage).toFixed(1)}%</h3>
            <p className="mb-0">Overall Accuracy</p>
          </div>
        </div>
      </div>
      <div className="col-md-3 mb-3">
        <div className="card border-info">
          <div className="card-body text-center">
            <i className="fas fa-clock fa-2x text-info mb-2"></i>
            <h3 className="text-info">{formatDuration(parseNumber(performanceSummary.total_time_spent_minutes))}</h3>
            <p className="mb-0">Study Time</p>
          </div>
        </div>
      </div>
      <div className="col-md-3 mb-3">
        <div className="card border-warning">
          <div className="card-body text-center">
            <i className="fas fa-trophy fa-2x text-warning mb-2"></i>
            <h3 className={`${getMasteryColor(performanceSummary.mastery_level)}`}>
              {performanceSummary.mastery_level}
            </h3>
            <p className="mb-0">Mastery Level</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickStatsCards;